import React from 'react'

import { Conteiner } from './styles'

export default function Footer() {
    return (
        <Conteiner>
            <p>© 2020</p>
        </Conteiner>
    )
}